import { subDays } from 'date-fns';

import {
	IDashboardAssetSummary,
	IDashboardRentsGeneralSummary,
} from '@interfaces/platform/platformDashboard';

export interface IStatisticSummaryList {
	list: {
		title: string;
		value: number;
		unit?: string;
	}[];
	title: string;
	total: number;
}

export const getSummaryListData = (data?: IDashboardAssetSummary): IStatisticSummaryList => {
	return {
		list: [
			{
				title: 'Hidden',
				value: data?.hiddenAssets || 0,
			},
			{
				title: 'On the map',
				value: data?.showedAssets || 0,
			},
		],
		title: 'All Assets',
		total: data?.allAssets || 0,
	};
};

export const getRequestsListData = (data?: IDashboardRentsGeneralSummary): IStatisticSummaryList => {
	return {
		list: [
			{
				title: 'Assets requested',
				value: data?.requestedAssets || 0,
			},
			{
				title: 'Assets arranged',
				value: data?.arrangedAssets || 0,
			},
			{
				title: 'Organisations',
				value: data?.organisations || 0,
			},
			{
				title: 'Total cost arranged',
				value: data?.arrangedTotalCost || 0,
				unit: '£',
			},
			{
				title: 'Platform earned',
				value: data?.poEarned || 0,
				unit: '£',
			},
		],
		title: 'Requests completed',
		total: data?.completedRequest || 0,
	};
};

export const getOrganizationRequestsListData = (data?: IDashboardRentsGeneralSummary): IStatisticSummaryList => {
	return {
		list: [
			{
				title: 'Assets requested',
				value: data?.requestedAssets || 0,
			},
			{
				title: 'Assets arranged',
				value: data?.arrangedAssets || 0,
			},
			{
				title: 'Arranged total cost ',
				value: data?.arrangedTotalCost || 0,
				unit: '£',
			},
			{
				title: 'Platform commission',
				value: data?.poEarned || 0,
				unit: '£',
			},
		],
		title: 'Requests completed',
		total: data?.completedRequest || 0,
	};
};

export const getRangeTimestamp = (range = 30) => {
	return {
		fromTimestamp: subDays(Date.now(), range),
		currentTimestamp: Date.now(),
	};
};
